import type { FetchArgs } from "@reduxjs/toolkit/query";

const KC_URLS = [
  process.env.CHANGE_PASSWORD_URL,
  process.env.MFA_RESET_URL,
  process.env.MFA_CONFIG_URL,
];

const isMSIQuery = (args: FetchArgs | string) => {
  const url = typeof args === "string" ? args : args.url;

  if (url.startsWith("/api/") || url.includes("/permissions/") || KC_URLS.includes(url)) {
    return true;
  }
  return false;
};
export default isMSIQuery;
